export default __webpack_public_path__ + "static/media/eyeGrayIcon.d4ef9802.svg";